import { Credit, CreditTransaction } from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class CreditsService extends CrudService {
  static override route = 'credits';

  async getCredits() {
    const response = await this.httpService.get<BaseResponse<number>>(
      this.path,
    );

    return response.data;
  }

  async getCreditsHistory() {
    const response = await this.httpService.get<
      BaseResponse<{ transactions: CreditTransaction[]; credits: Credit[] }>
    >(`${this.path}/credits-history`);

    return response.data;
  }
}
